module.exports = __webpack_public_path__ + "static/media/introduction.87e90bab.svg";